import Axios from '../Axios';

const auth = {
	auth(data) {
		return Axios.post('/login/admin', data);
	},
};

export default auth;
